import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation, input, computed } from '@angular/core';
import { IOnboardingActive } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';
import { FiOnboardingActiveHelperService } from '../fi-onboarding-active-helper.service';
import { FiOnboardingCategoryType } from '../../fi-onboarding-enums';

@Component({
    selector: 'fi-onboarding-active-item',
    templateUrl: './fi-onboarding-active-item.component.html',
    styleUrl: './fi-onboarding-active-item.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-active-item' },
    standalone: false,
})
export class FiOnboardingActiveItemComponent {
    public onboarding = input.required<IOnboardingActive>();

    private readonly fiOnboardingActiveHelperService = inject(FiOnboardingActiveHelperService);
    protected cardIconClass = computed(() =>
        this.fiOnboardingActiveHelperService.getOnboardingIconClassByType(this.onboarding().Category),
    );
    protected buttonLabel = computed(() =>
        this.fiOnboardingActiveHelperService.getOnboardingCardButtonLabelByStatus(this.onboarding().Status),
    );
    protected isSynchronizedOnboarding = computed(
        () => this.onboarding().Category === FiOnboardingCategoryType.Synchronized,
    );
}
